import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change } from "redux-form";
import TextField from "../../components/Fields/TextField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import logo from "../../img/e-registro-logo.png";
import FieldValidation from "../../components/Validation/FieldValidation";
import MaskDate from "../../components/Util/MaskDate";
import MaskDecimal from "../../components/Util/MaskDecimal";
import { toastr } from "react-redux-toastr";
import api from "../../api/apiUtil";
import fileDownload from "js-file-download";
import { filePdf } from "react-icons-kit/icomoon/filePdf";
import SvgIcon from "react-icons-kit";
// Not found page component
class Consulta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      result: false,
      paramViaUrl: false,
      id: null,
    };
  }
  componentDidMount() {
    if (this.props.params.chassi && this.props.params.cpf) {
      let params = {
        numChassi: this.props.params.chassi,
        numDevCpfCnpj: this.props.params.cpf,
      };
      this.formSubmit(params);
      this.setState({ paramViaUrl: true });
    }
  }

  formSubmit(values) {
    const params = {
      numChassi: values.numChassi,
      numDevCpfCnpj: values.numDevCpfCnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase(),
    };
    Promise.resolve(api.Auth.consultaPublica(params))
      .then((result) => {
        if (result) {
          this.preencheForm(result);
          this.setState({ result: true, id: result.id });
        } else {
          toastr.warning("Atenção", "Nenhum resultado encontrado!");
        }
      })
      .catch(function (resp) {
        toastr.error("Atenção", resp.response.text);
      });
  }

  preencheForm(result) {
    this.props.dispatch(change("ConsultaForm", "numero", result.numero));
    this.props.dispatch(change("ConsultaForm", "data", MaskDate.TO_BR(result.data)));
    this.props.dispatch(change("ConsultaForm", "devCpfCnpj", result.devCpfCnpj));
    this.props.dispatch(change("ConsultaForm", "devNome", result.devNome));
    this.props.dispatch(change("ConsultaForm", "valorTotalFinanciamento", MaskDecimal.TO_BR_TO_REAL(result.valorTotalFinanciamento)));
    this.props.dispatch(change("ConsultaForm", "chassi", result.chassi));
    this.props.dispatch(change("ConsultaForm", "renavam", result.renavam));
    this.props.dispatch(change("ConsultaForm", "numGravame", result.numGravame));
    this.props.dispatch(change("ConsultaForm", "razaoSocial", result.razaoSocial));
  }

  retornar() {
    this.setState({ result: false });
    this.props.dispatch(change("ConsultaForm", "numChassi", null));
    this.props.dispatch(change("ConsultaForm", "numDevCpfCnpj", null));
  }

  exportContractPDF = () => async (ev) => {
    var props = this.props;
    Promise.resolve(api.Contracts.espelho(this.state.id))
      .then((ret) => {
        fileDownload(ret, `Espelho.pdf`);
      })
      .catch(function (resp) {
        if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", resp.message);
        }
      });
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <div className="color-line-ereg"></div>
        <div className="login-img-container">
          <img src={logo} />
        </div>
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    {this.state.result && (
                      <button className="btn btn-xs btn-info" style={{ margin: "0 2px" }} onClick={this.exportContractPDF()}>
                        {" "}
                        <SvgIcon size={15} icon={filePdf} />
                        Gerar Espelho
                      </button>
                    )}
                  </div>
                  <h5>Consultar contrato</h5>
                </div>
                {!this.state.result ? (
                  <div className="panel-body">
                    <form onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                      <div className="row">
                        <div className="col-md-6">
                          <Field
                            name="numChassi"
                            label="4 Primeiros Números do Chassi"
                            component={TextField}
                            validate={[FieldValidation.required, FieldValidation.nospace, FieldValidation.length4]}
                            maxlength={4}
                            type="text"
                            inline={false}
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <Field
                            name="numDevCpfCnpj"
                            label="CPF/CNPJ do Devedor"
                            normalize={FieldNormalize.CPF_CNPJ}
                            component={TextField}
                            validate={[FieldValidation.required]}
                            type="text"
                            inline={false}
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="text-center">
                            <button type="submit" className="btn btn-xs btn-success">
                              Consultar
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                ) : (
                  <div className="panel-body">
                    <form>
                      <div className="row">
                        <div className="col-md-3">
                          <Field name="numero" label="Número" component={TextField} type="text" inline={false} disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="data" label="Data" type="text" inline={false} disabled component={TextField} />
                        </div>
                        <div className="col-md-3">
                          <Field name="devCpfCnpj" label="CPF/CNPJ do Devedor" component={TextField} type="text" inline={false} disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="devNome" label="Nome Devedor" component={TextField} type="text" inline={false} disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="valorTotalFinanciamento" label="Valor Total Financiamento" component={TextField} type="text" inline={false} disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="chassi" label="Chassi" component={TextField} type="text" inline={false} disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="renavam" label="Renavam" component={TextField} type="text" inline={false} disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="numGravame" label="Número Gravame" component={TextField} type="text" inline={false} disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="razaoSocial" label="Credor" component={TextField} type="text" inline={false} disabled />
                        </div>
                      </div>
                      {!this.state.paramViaUrl && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="text-center">
                              <button type="button" className="btn btn-xs btn-success" onClick={this.retornar.bind(this)}>
                                Retornar
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

const form = reduxForm({
  form: "ConsultaForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(Consulta));
